import { apiClient } from "lib/apiClient";
import { IResearchWorkItem } from "features/Research/types";

export const getResearchWorkItem = async (
  workItemId: string
): Promise<IResearchWorkItem> => {
  const response = await apiClient.get(`/research/work-items/${workItemId}`);
  return response.data;
};
